import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useTranslations } from "next-intl";
import { ErrorComponent, ErrorComponentProps } from "@components/errors/error-component";
export const NotFound = props => {
  const $ = _c(11);
  const t = useTranslations("common.errors");
  let t0;
  if ($[0] !== t) {
    t0 = t("notFound.title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("notFound.subTitle");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("notFound.description");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t0 || $[8] !== t1 || $[9] !== t2) {
    t3 = <ErrorComponent title={t0} subTitle={t1} description={t2} {...props} />;
    $[6] = props;
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};